<template>
  <b-modal
    no-fade
    size="xl2"
    id="modal-nivel-sintetico"
    no-close-on-esc
    no-close-on-backdrop
    @show="onShow"
    :title="
      `Nível Sintético - ${
        acao == 'new' ? 'Novo' : `${wbs.wbs_id} - ${wbs.componente}`
      }`
    "
  >
    <b-tabs
      content-class="v-tab-content"
      v-model="tabIndex"
      active-nav-item-class="v-tab-active"
      small
    >
      <b-tab title="Nível EAP">
        <b-form-row>
          <b-col md="12" sm="12" lg="12">
            <b-form-group label="Nível" label-size="sm" label-for="wbs_id">
              <b-form-input
                disabled
                size="sm"
                maxlength="50"
                id="wbs_id"
                v-model="wbs.wbs_id"
                trim
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col lg="12">
            <b-form-group
              label-size="sm"
              label="Tipo de Serviço"
              label-for="tipo_servico_id"
            >
              <v-select
                :disabled="disableState"
                id="tipo_servico_id"
                :options="tiposServico"
                label="tipo_id"
                :reduce="(t) => t.tipo_id"
                :clearable="false"
                v-model="wbs.tipo_servico_id"
                :filter="doFiltroTipoServico"
              >
                <template v-slot:option="option">{{
                  `${option.tipo_id} - ${option.descricao}`
                }}</template>
                <template v-slot:selected-option="option">{{
                  `${option.tipo_id} - ${option.descricao}`
                }}</template>
                <template #no-options="{}">Sem dados a serem exibidos</template>
              </v-select>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col lg="12">
            <b-form-group
              label="Componente"
              label-size="sm"
              label-for="componente"
            >
              <b-textarea
                :disabled="disableState"
                no-resize
                v-model="wbs.componente"
                maxlength="255"
                rows="2"
              ></b-textarea>
            </b-form-group>
          </b-col>
        </b-form-row>
      </b-tab>
      <b-tab title="Financeiro" :disabled="acao == 'new'">
        <TabFinanceiro :wbs="wbs" :acao="acao" :sintetico="true" />
      </b-tab>
      <b-tab title="Planejamento" :disabled="acao == 'new'">
        <SubTabPlanejamentoSintetico :wbs="wbs" />
      </b-tab>
    </b-tabs>

    <template v-slot:modal-footer>
      <b-button
        v-show="tabIndex == 0"
        size="sm"
        @click="saveWBS()"
        variant="primary"
      >
        <i class="fas fa-check"></i> Gravar
      </b-button>
      <b-button size="sm" @click="() => $bvModal.hide('modal-nivel-sintetico')"
        >Fechar</b-button
      >
    </template>
  </b-modal>
</template>

<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import TabFinanceiro from "./TabFinanceiro.vue";
import SubTabPlanejamentoSintetico from "./SubTabPlanejamentoSintetico.vue";

export default {
  name: "ModalNivelSintetico",
  components: { TabFinanceiro, SubTabPlanejamentoSintetico },
  props: {
    wbs: { type: Object, required: true },
    acao: { type: String, required: true, default: "view" },
  },
  computed: {
    disableState: function() {
      return this.acao == "view";
    },
  },
  data: function() {
    return {
      tabIndex: 0,
      tiposServico: [],
    };
  },
  methods: {
    doFiltroTipoServico(options, search) {
      return options.filter((f) => {
        return (
          f.descricao.toLowerCase().indexOf(search.toLowerCase()) > -1 ||
          f.tipo_id
            .toString()
            .toLowerCase()
            .indexOf(search.toLowerCase()) > -1
        );
      });
    },
    onShow() {
      // tipos de servico
      axios
        .get(`${baseApiUrl}/bid/tiposservico`)
        .then((resp) => {
          this.tiposServico = resp.data;
        })
        .catch(showError);
    },
    saveWBS() {
      this.wbs.ind_analitico = false;
      this.wbs.ind_fonte = 1;
      this.wbs.cotacao_base = 1;

      let _msg = "";

      if ((this.wbs.componente || "") === "") _msg = "Informe o Componente";

      if ((this.wbs.tipo_servico_id || "") === "")
        _msg += (_msg !== "" ? "<br/>" : "") + "Selecione o Tipo de Serviço!";

      if (_msg !== "") {
        this.$toasted.info(_msg, {
          duration: 4000,
          keepOnHover: true,
          className: "v-toasted-warning",
        });
        return false;
      }

      if (this.acao == "new") {
        axios
          .post(
            `${baseApiUrl}/bid/programawbs/${btoa(this.wbs.programa_id)}`,
            this.wbs
          )
          .then(() => {
            this.$emit("updatedWBS", this.wbs);
            this.$bvModal.hide("modal-nivel-sintetico");
          })
          .catch((ex) => {
            showError(ex);
            console.log(ex);
          });
      } else if (this.acao == "edit") {
        axios
          .put(
            `${baseApiUrl}/bid/programawbs/${btoa(this.wbs.programa_id)}/${
              this.wbs.wbs_id
            }`,
            this.wbs
          )
          .then(() => {
            this.$emit("updatedWBS", this.wbs);
            this.$bvModal.hide("modal-nivel-sintetico");
          })
          .catch((ex) => {
            showError(ex);
            console.log(ex);
          });
      }
    },
  },
};
</script>

<style></style>
